export const TIPO = {
    impianto: { color: '#1565C0', bg: '#EBF2FC', label: 'Impianti' },
    lezione:  { color: '#FF9800', bg: '#FFF8E1', label: 'Lezioni' },
    corso:    { color: '#00A15D', bg: '#E8F5EE', label: 'Corsi e squadre' },
    generico: { color: '#7B1FA2', bg: '#F3E5F5', label: 'Generici' },
};

const MESI_SHORT_UP = ['GEN','FEB','MAR','APR','MAG','GIU','LUG','AGO','SET','OTT','NOV','DIC'];

// Trasforma un evento API nel formato usato dalle viste
export function apiToViewEvento(ev) {
    const start = new Date(ev.dataInizio);
    const end   = new Date(ev.dataFine);
    const pad   = n => String(n).padStart(2, '0');
    return {
        ...ev,
        oraInizio: `${pad(start.getHours())}:${pad(start.getMinutes())}`,
        oraFine:   `${pad(end.getHours())}:${pad(end.getMinutes())}`,
        giorno:    start.getDate(),
        mese:      MESI_SHORT_UP[start.getMonth()],
        data:      ev.dataInizio.substring(0, 10),
        pagato:    ev.statoPagemento === 'pagato',
    };
}

// Restituisce YYYY-MM-DD di una Date
export function toDateKey(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
}

// Restituisce stringa ISO per API (inizio/fine giornata)
export function toDayRange(d) {
    const key = toDateKey(d);
    return { da: `${key}T00:00:00`, a: `${key}T23:59:59` };
}

// Risorse disponibili per il filtro sinistro
export const RISORSE = {
    impianti: [
        { id: 'i1', nome: 'Campo 1',     count: 14, checked: true },
        { id: 'i2', nome: 'Campo 2',     count: 78, checked: true },
        { id: 'i3', nome: 'Sala Pesi',   count: 7,  checked: true },
        { id: 'i4', nome: 'Piscina',     count: 7,  checked: true },
    ],
    lezioni: [
        { id: 'l1', nome: 'Marco V.',    count: 14, checked: true },
        { id: 'l2', nome: 'Sara P.',     count: 78, checked: false },
        { id: 'l3', nome: 'Luca R.',     count: 7,  checked: false },
    ],
    corsi: [
        { id: 'c1', nome: 'Corso 1',      count: 14, checked: true },
        { id: 'c2', nome: 'Corso 2',      count: 78, checked: true },
        { id: 'c3', nome: 'Nome squadra', count: 7,  checked: true },
        { id: 'c4', nome: 'Nome squadra', count: 7,  checked: true },
    ],
};

// Slot orari disponibili
export const ORE = [
    '08:00','09:00','10:00','11:00','12:00','13:00',
    '14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00',
];

// ── Mock Giorno ──────────────────────────────────────────────────
const eg = (id, type, titolo, ora, pagato) => ({
    id, type, titolo,
    oraInizio: ora, oraFine: ora.replace(/\d{2}$/, '00').replace(/(\d+):/, (_, h) => `${parseInt(h)+1}:`),
    tipologia: 'Tipologia', pagato,
});

export const mockEventiGiorno = [
    // 07:00
    eg(100, 'impianto', '[Nome impianto]', '07:00', false),
    eg(101, 'lezione',  '[Nome maestro]',  '07:00', true),
    eg(102, 'corso',    '[Nome corso]',    '07:00', true),
    // 09:00
    eg(103, 'impianto', '[Nome impianto]', '09:00', true),
    eg(104, 'lezione',  '[Nome maestro]',  '09:00', false),
    // 11:00
    eg(105, 'impianto', '[Nome impianto]', '11:00', false),
    eg(106, 'lezione',  '[Nome maestro]',  '11:00', true),
    eg(107, 'corso',    '[Nome corso]',    '11:00', true),
    // 12:00 (overflow → +2)
    eg(108, 'impianto', '[Nome impianto]', '12:00', false),
    eg(109, 'impianto', '[Nome impianto]', '12:00', false),
    eg(110, 'lezione',  '[Nome maestro]',  '12:00', true),
    eg(111, 'corso',    '[Nome corso]',    '12:00', true),
    eg(112, 'impianto', '[Nome impianto]', '12:00', false),
    eg(113, 'lezione',  '[Nome maestro]',  '12:00', true),
    // 13:30
    eg(114, 'impianto', '[Nome impianto]', '13:30', true),
    eg(115, 'lezione',  '[Nome maestro]',  '13:30', false),
    // 14:00 (overflow → +4)
    eg(116, 'impianto', '[Nome impianto]', '14:00', false),
    eg(117, 'lezione',  '[Nome maestro]',  '14:00', true),
    eg(118, 'corso',    '[Nome corso]',    '14:00', true),
    eg(119, 'corso',    '[Nome corso]',    '14:00', true),
    eg(120, 'impianto', '[Nome impianto]', '14:00', false),
    eg(121, 'lezione',  '[Nome maestro]',  '14:00', false),
    eg(122, 'corso',    '[Nome corso]',    '14:00', true),
    eg(123, 'corso',    '[Nome corso]',    '14:00', false),
];

// ── Mock Timeline ─────────────────────────────────────────────────
const et = (id, titolo, oraInizio, oraFine, pagato) => ({
    id, titolo, oraInizio, oraFine, tipologia: 'Tipologia', pagato,
});

export const mockEventiTimeline = {
    impianti: [
        et(200, '[Nome impianto]', '08:30', '09:30', true),
        et(201, '[Nome impianto]', '09:00', '10:00', true),
    ],
    lezioni: [
        et(202, '[Nome maestro]', '08:00', '09:00', true),
        et(203, '[Nome maestro]', '09:10', '10:10', false),
    ],
    corsi: [
        et(204, '[Nome corso]', '08:40', '09:40', true),
        et(205, '[Nome corso]', '09:20', '10:20', false),
    ],
};

// ── Mock Mese (Ottobre 2026) ──────────────────────────────────────
export const mockEventiMese = [
    // Sep 29
    { id: 501, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-09-29', tipologia: 'Tipologia',         pagato: true  },
    { id: 502, type: 'lezione',  titolo: '[Nome evento]',   data: '2026-09-29', tipologia: 'Sala pesi - Nome C.', pagato: false },
    // Oct 4
    { id: 503, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-04', tipologia: 'Tipologia', pagato: true  },
    // Oct 7
    { id: 504, type: 'lezione',  titolo: '[Nome maestro]',  data: '2026-10-07', tipologia: 'Tipologia', pagato: false },
    // Oct 8
    { id: 505, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-08', tipologia: 'Tipologia', pagato: true  },
    { id: 506, type: 'lezione',  titolo: '[Nome maestro]',  data: '2026-10-08', tipologia: 'Tipologia', pagato: false },
    { id: 507, type: 'corso',    titolo: '[Nome corso]',    data: '2026-10-08', tipologia: 'Tipologia', pagato: true  },
    // Oct 13
    { id: 508, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-13', tipologia: 'Tipologia', pagato: true  },
    { id: 509, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-13', tipologia: 'Tipologia', pagato: true  },
    // Oct 17
    { id: 510, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-17', tipologia: 'Tipologia', pagato: true  },
    { id: 511, type: 'lezione',  titolo: '[Nome maestro]',  data: '2026-10-17', tipologia: 'Tipologia', pagato: false },
    // Oct 21
    { id: 512, type: 'corso',    titolo: '[Nome corso]',    data: '2026-10-21', tipologia: 'Tipologia', pagato: false },
    // Oct 24
    { id: 513, type: 'lezione',  titolo: '[Nome maestro]',  data: '2026-10-24', tipologia: 'Tipologia', pagato: false },
    // Oct 25
    { id: 514, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-25', tipologia: 'Tipologia', pagato: false },
    // Oct 29
    { id: 515, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-10-29', tipologia: 'Tipologia', pagato: true  },
    { id: 516, type: 'corso',    titolo: '[Nome corso]',    data: '2026-10-29', tipologia: 'Tipologia', pagato: true  },
    // Oct 30
    { id: 517, type: 'corso',    titolo: '[Nome corso]',    data: '2026-10-30', tipologia: 'Tipologia', pagato: false },
    // Nov 1
    { id: 518, type: 'lezione',  titolo: '[Nome maestro]',  data: '2026-11-01', tipologia: 'Tipologia', pagato: true  },
    { id: 519, type: 'impianto', titolo: '[Nome Impianto]', data: '2026-11-01', tipologia: 'Tipologia', pagato: true  },
];

// ── Mock Settimana (Lun 12 - Dom 18 ottobre 2026) ─────────────────
// giorno = day-of-month, used to group into the correct column
export const mockEventiSettimana = [
    // Mar 13
    { id: 401, type: 'corso',    titolo: '[Nome corso]',   giorno: 13, oraInizio: '07:00', oraFine: '11:00', tipologia: 'Tipologia', pagato: true  },
    { id: 402, type: 'impianto', titolo: '[N. Impianto]',  giorno: 13, oraInizio: '08:00', oraFine: '09:00', tipologia: 'Tipologia', pagato: true  },
    { id: 403, type: 'lezione',  titolo: '[N. Maestro]',   giorno: 13, oraInizio: '11:00', oraFine: '12:00', tipologia: 'Tipologia', pagato: true  },
    // Mer 14
    { id: 404, type: 'lezione',  titolo: '[N. Maestro]',   giorno: 14, oraInizio: '09:00', oraFine: '10:00', tipologia: 'Tipologia', pagato: false },
    { id: 405, type: 'impianto', titolo: '[N. Impianto]',  giorno: 14, oraInizio: '12:00', oraFine: '13:00', tipologia: 'Sala pesi', pagato: false },
    // Gio 15
    { id: 406, type: 'lezione',  titolo: '[N. Maestro]',   giorno: 15, oraInizio: '07:00', oraFine: '11:00', tipologia: 'Tipologia', pagato: true  },
    { id: 407, type: 'impianto', titolo: '[N. Impianto]',  giorno: 15, oraInizio: '11:00', oraFine: '12:00', tipologia: 'Tipologia', pagato: false },
    // Ven 16
    { id: 408, type: 'corso',    titolo: '[Nome corso]',   giorno: 16, oraInizio: '08:00', oraFine: '09:00', tipologia: 'Tipologia', pagato: true  },
    { id: 409, type: 'impianto', titolo: '[N. Impianto]',  giorno: 16, oraInizio: '09:00', oraFine: '10:00', tipologia: 'Tipologia', pagato: false },
    // Dom 18
    { id: 410, type: 'corso',    titolo: '[Nome corso]',   giorno: 18, oraInizio: '10:00', oraFine: '11:00', tipologia: 'Tipologia', pagato: false },
];

// ── Helper per generare eventi mock in bulk ───────────────────────
const ev = (id, tipo, titolo, pagato) => ({
    id, titolo, giorno: 14, mese: 'SEP',
    oraInizio: '10:00', oraFine: '11:00',
    tipologia: 'Tipologia', pagato,
});

// Colonna normale (3 cards visibili)
export const mockEventiOra = {
    impianti: [
        ev(1,  'impianto', '[Nome impianto]', true),
        ev(2,  'impianto', '[Nome impianto]', true),
        ev(3,  'impianto', '[Nome impianto]', true),
        ev(4,  'impianto', '[Nome impianto]', true),
    ],
    lezioni: [
        ev(10, 'lezione',  '[Nome maestro]',  true),
        ev(11, 'lezione',  '[Nome maestro]',  true),
        ev(12, 'lezione',  '[Nome maestro]',  true),
        ev(13, 'lezione',  '[Nome maestro]',  true),
        ev(14, 'lezione',  '[Nome maestro]',  true),
    ],
    corsi: [
        ev(20, 'corso',    '[Nome corso]',    true),
        ev(21, 'corso',    '[Nome corso]',    true),
        ev(22, 'corso',    '[Nome corso]',    true),
    ],
};

// Vista espansa (più eventi, mix pagato/non pagato)
export const mockEventiOraExpanded = {
    impianti: [
        ev(30, 'impianto', '[Nome impianto]', true),
        ev(31, 'impianto', '[Nome impianto]', true),
        ev(32, 'impianto', '[Nome impianto]', false),
        ev(33, 'impianto', '[Nome impianto]', false),
        ev(34, 'impianto', '[Nome impianto]', true),
        ev(35, 'impianto', '[Nome impianto]', true),
        ev(36, 'impianto', '[Nome impianto]', true),
        ev(37, 'impianto', '[Nome impianto]', false),
        ev(38, 'impianto', '[Nome impianto]', true),
        ev(39, 'impianto', '[Nome impianto]', false),
        ev(40, 'impianto', '[Nome impianto]', true),
    ],
    lezioni: [
        ev(50, 'lezione', '[Nome maestro]', true),
        ev(51, 'lezione', '[Nome maestro]', false),
        ev(52, 'lezione', '[Nome maestro]', true),
        ev(53, 'lezione', '[Nome maestro]', true),
        ev(54, 'lezione', '[Nome maestro]', false),
        ev(55, 'lezione', '[Nome maestro]', true),
        ev(56, 'lezione', '[Nome maestro]', true),
        ev(57, 'lezione', '[Nome maestro]', false),
        ev(58, 'lezione', '[Nome maestro]', true),
    ],
    corsi: [
        ev(70, 'corso', '[Nome corso]', true),
        ev(71, 'corso', '[Nome corso]', false),
        ev(72, 'corso', '[Nome corso]', true),
        ev(73, 'corso', '[Nome corso]', true),
        ev(74, 'corso', '[Nome corso]', false),
        ev(75, 'corso', '[Nome corso]', true),
        ev(76, 'corso', '[Nome corso]', true),
        ev(77, 'corso', '[Nome corso]', false),
        ev(78, 'corso', '[Nome corso]', true),
    ],
};
